var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotificationFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.483h21v-3.298l-1.449-1.887V9.007C21.551 4.04 17.498 0 12.513 0 7.53 0 3.475 4.04 3.475 9.007v5.291L2 16.218v3.265ZM12.447 22.45c.944 0 1.768-.622 2.033-1.51v-.006h1.595c-.003.023-.008.046-.013.07a.989.989 0 0 0-.013.069C15.697 22.768 14.274 24 12.447 24a3.67 3.67 0 0 1-3.629-3.06h1.595a2.14 2.14 0 0 0 2.034 1.51Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/NotificationFilled.7bfc40fb237430bc34ff8c887352f99e.svg";